/* Secuencia de imágenes sincronizada con el scroll (técnica tipo Apple): el frasco que se destapa en la sección Club.
   - Dibuja en un <canvas> el cuadro que corresponde al avance del scroll; avanza y retrocede sin trabas (no depende de video.currentTime).
   - Carga perezosa: el primer cuadro apenas se acerca la sección; el resto en orden, de a pocos, cuando está por entrar.
   - Suavizado: el cuadro mostrado persigue al cuadro objetivo (lerp), así un scroll brusco se ve como un movimiento continuo.
   - Nítido en pantallas retina (devicePixelRatio, tope 2) y recorte tipo object-fit: cover.
   - prefers-reduced-motion: muestra el último cuadro quieto y todos los textos.
   Uso: <canvas data-seq="img/destapado/seq/d/{i}.webp" data-seq-m="img/destapado/seq/m/{i}.webp" data-frames="121">
   Expone window.MkSeq.set(p) para que la escena le pase el avance (0 → 1). */
(function () {
  const cv = document.querySelector('canvas[data-seq]'); if (!cv) return;
  const ctx = cv.getContext('2d', { alpha: false });
  const N = +cv.dataset.frames || 1;
  const mq = matchMedia('(max-aspect-ratio: 4/5)');     // pantalla vertical (celular parado) → secuencia vertical; si no, la apaisada
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = i => String(i).padStart(3, '0');
  let set = null, imgs = [], target = 0, shown = -1, cur = 0, raf = 0, started = false;

  function pick() {                                  // compu o celular según el ancho; si cambia, recarga
    const s = mq.matches ? cv.dataset.seqM : cv.dataset.seq;
    if (s === set) return;
    set = s; imgs = new Array(N); shown = -1; started = false;
    if (inView) start();
  }
  function load(i) {
    if (imgs[i]) return imgs[i];
    const im = new Image(); im.decoding = 'async';
    im.src = set.replace('{i}', pad(i));
    im.onload = () => { if (Math.round(cur) === i || shown === -1 || Math.abs(shown - Math.round(cur)) > Math.abs(i - Math.round(cur))) draw(true); };
    return (imgs[i] = im);
  }
  function start() {                                 // primero el cuadro inicial y el final; después el resto, en tandas
    if (started) return; started = true;
    load(0); load(N - 1);
    let i = 1;
    (function batch() {
      const end = Math.min(N - 1, i + 12);
      for (; i < end; i++) load(i);
      if (i < N - 1) setTimeout(batch, 40);              // tandas chicas: no compite con el scroll ni con el resto de la página
    })();
  }
  function nearestLoaded(i) {                        // si el cuadro pedido no llegó, el más cercano que sí
    for (let d = 0; d < N; d++) {
      const a = imgs[i - d], b = imgs[i + d];
      if (a && a.complete && a.naturalWidth) return a;
      if (b && b.complete && b.naturalWidth) return b;
    }
    return null;
  }
  function size() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2), r = cv.getBoundingClientRect();
    const w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; shown = -1; ctx.fillStyle = '#4F543E'; ctx.fillRect(0, 0, w, h); }   // mientras carga: el verde del fondo, nunca negro
  }
  function draw(force) {
    const i = Math.max(0, Math.min(N - 1, Math.round(cur)));
    if (!force && i === shown) return;
    const im = nearestLoaded(i); if (!im) return;
    const cw = cv.width, ch = cv.height, s = Math.max(cw / im.naturalWidth, ch / im.naturalHeight);
    const w = im.naturalWidth * s, h = im.naturalHeight * s;
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';   // escalado de mejor calidad
    ctx.drawImage(im, (cw - w) / 2, (ch - h) / 2, w, h);   // cover, centrado
    shown = i;
  }
  function loop() {
    raf = 0;
    const d = target - cur;
    cur = Math.abs(d) < 0.05 ? target : cur + d * 0.22;       // persigue al objetivo: suave pero sin retraso notable
    draw(false);
    if (cur !== target) raf = requestAnimationFrame(loop);
  }

  let inView = false;
  new IntersectionObserver(es => es.forEach(e => { inView = e.isIntersecting; if (inView) start(); }), { rootMargin: '150% 0px' }).observe(cv);
  addEventListener('resize', () => { pick(); size(); draw(true); });
  mq.addEventListener ? mq.addEventListener('change', pick) : mq.addListener(pick);
  pick(); size();

  window.MkSeq = {
    set(p) {                                          // p: 0 → 1
      pick(); if (!started) start();                  // la escena está activa: asegurar la secuencia correcta y su carga
      target = reduce ? N - 1 : Math.max(0, Math.min(1, p)) * (N - 1);
      if (reduce) { cur = target; draw(true); return; }
      if (!raf) raf = requestAnimationFrame(loop);
    }
  };
  if (reduce) { start(); window.MkSeq.set(1); }
})();
